// Constantes partagées du système de support (catégories, urgences, statuts).
// Palette urgence STRICTE : faible=slate, normal=blue, élevé=amber, critique=red.
// JAMAIS de violet/indigo (réservé à l'IA — cf. DESIGN_SYSTEM.md).

export const SUPPORT_CATEGORIES = [
  { value: 'bug_fonctionnel', label: 'Bug fonctionnel', icon: 'bi-exclamation-octagon' },
  { value: 'bug_visuel', label: "Bug d'affichage", icon: 'bi-bounding-box' },
  { value: 'question', label: 'Question', icon: 'bi-question-circle' },
  { value: 'suggestion', label: 'Suggestion', icon: 'bi-lightbulb' },
  { value: 'restauration', label: 'Restauration de données', icon: 'bi-clock-history' },
  { value: 'autre', label: 'Autre', icon: 'bi-three-dots' },
];

export const SUPPORT_CATEGORY_LABELS = Object.fromEntries(
  SUPPORT_CATEGORIES.map((c) => [c.value, c.label])
);

export const SUPPORT_URGENCES = [
  {
    value: 'faible',
    label: 'Faible',
    chip: 'bg-slate-100 text-slate-700 border border-slate-200',
    dot: 'bg-slate-400',
    selected: 'border-slate-500 bg-slate-50 text-slate-800 ring-1 ring-slate-300',
  },
  {
    value: 'normal',
    label: 'Normal',
    chip: 'bg-blue-100 text-blue-700 border border-blue-200',
    dot: 'bg-blue-500',
    selected: 'border-blue-500 bg-blue-50 text-blue-700 ring-1 ring-blue-300',
  },
  {
    value: 'eleve',
    label: 'Élevé',
    chip: 'bg-amber-100 text-amber-700 border border-amber-200',
    dot: 'bg-amber-500',
    selected: 'border-amber-500 bg-amber-50 text-amber-700 ring-1 ring-amber-300',
  },
  {
    value: 'critique',
    label: 'Critique',
    chip: 'bg-red-100 text-red-700 border border-red-200',
    dot: 'bg-red-500',
    selected: 'border-red-500 bg-red-50 text-red-700 ring-1 ring-red-300',
  },
];

export const SUPPORT_URGENCE_MAP = Object.fromEntries(
  SUPPORT_URGENCES.map((u) => [u.value, u])
);

export const SUPPORT_STATUSES = [
  { value: 'nouveau', label: 'Nouveau', chip: 'bg-blue-100 text-blue-700' },
  { value: 'en_cours', label: 'En cours', chip: 'bg-amber-100 text-amber-700' },
  { value: 'resolu', label: 'Résolu', chip: 'bg-emerald-100 text-emerald-700' },
  { value: 'ferme', label: 'Fermé', chip: 'bg-slate-100 text-slate-600' },
  { value: 'rouvert', label: 'Rouvert', chip: 'bg-orange-100 text-orange-700' },
  { value: 'rejete', label: 'Rejeté', chip: 'bg-slate-200 text-slate-500' },
];

export const SUPPORT_STATUS_MAP = Object.fromEntries(
  SUPPORT_STATUSES.map((s) => [s.value, s])
);

// Capture allégée : un PNG plein écran pèse 1 à 4 Mo, qui doivent monter du navigateur PUIS
// du serveur vers le stockage. En JPEG 0,8 borné à 1600 px de large, on divise le poids par
// 5 à 10 sans perdre la lisibilité d'une copie d'écran d'interface.
export const SCREENSHOT_MAX_WIDTH = 1600;
export const SCREENSHOT_QUALITY = 0.8;

export function canvasToCompressedDataURL(canvas, maxWidth = SCREENSHOT_MAX_WIDTH, quality = SCREENSHOT_QUALITY) {
  if (canvas.width <= maxWidth) return canvas.toDataURL('image/jpeg', quality);
  const ratio = maxWidth / canvas.width;
  const target = document.createElement('canvas');
  target.width = maxWidth;
  target.height = Math.round(canvas.height * ratio);
  const ctx = target.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, target.width, target.height);
  ctx.drawImage(canvas, 0, 0, target.width, target.height);
  return target.toDataURL('image/jpeg', quality);
}

// dataURL (image/jpeg ou image/png) → Blob pour upload multipart
export function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mime = (arr[0].match(/:(.*?);/) || [])[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8 = new Uint8Array(n);
  while (n--) u8[n] = bstr.charCodeAt(n);
  return new Blob([u8], { type: mime });
}
